import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';
import { ProjectSiteConfig } from 'app/home/types';

import { apiQuery } from '../../query';

import { ProjectSiteConfigResponse } from './types';

export const projectsApi = createApi({
  baseQuery: apiQuery,
  reducerPath: 'projectsApi',
  endpoints: (build) => ({
    siteConfig: build.query<ProjectSiteConfig, void>({
      query: () => ({
        method: 'get',
        url: URL.PROJECT_SITE_CONFIG,
      }),
      transformResponse: (response: ProjectSiteConfigResponse) =>
        response.data.siteConfig,
    }),
  }),
});

export const { useSiteConfigQuery } = projectsApi;
